<template>
  <div>
    <apexchart :width="!$q.screen.lt.md?'500':'350'"  :options="orderChartOptions" :series="orderChartSeries"></apexchart>
  </div>
</template>

<script>
export default {
  name: "LineChart",
  props: ['items', 'data', 'title'],
  data() {
    return {
      orderChartOptions: {
        chart: {
          id: 'mainChart',
          type: 'bar',
          toolbar: {
            show: false
          }
        },
        title: {
          text: this.title,
          align: 'center',
          floating: false,
          style: {
            fontFamily: 'IRANSans, sans-serif'
          }
        },
        xaxis: {
          labels: {
            hideOverlappingLabels: true,
            rotate: -45
          },
          categories: this.items.map(item => item.Month)
        },
        yaxis:{
          labels:{
            show:false
          }
        }
      },
      orderChartSeries: [{
        name: 'مقدار',
        data: this.data
      }],
    }
  },
  created() {
  }
}
</script>

<style scoped>

</style>